import { render, staticRenderFns } from "./ModalGenerateReport.vue?vue&type=template&id=ffcd0468&"
import script from "./ModalGenerateReport.vue?vue&type=script&lang=js&"
export * from "./ModalGenerateReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports